import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { MyPage } from '@web/app/features/my-page/pages';
import { DefaultLayout2 } from '@web/app/shared';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export const MyPageRoutes = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<DefaultLayout2 />}>
                    <Route path="/" element={<MyPage />}></Route>
                    <Route path="*" element={<Navigate to="/my-page"></Navigate>}></Route>
                </Route>
            </Routes>
        </>
    );
};
